import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import * as API from "../../libs/service";

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import Popup01 from "../popup/Popup01";

import PaginationSetLicense from '../../components/PaginationSetLicense';
import { setArt, setEdu, setOrganization, setPro } from "../../redux/licenseSlice";
import { refreshLicenseData } from "../../libs/utils";

export default function PopupLicensing(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        max_width,
        popType,
        perType,
        stateType,
        modelType,
        view,
        license,
        user
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const organization = useSelector((s) => s.licenseReducer.organization);

    const [LicenseidValue, setLicenseIdValue] = useState('');
    const [LicenseidErr, setLicenseIdErr] = useState(0);
    const [educationStep, setEducationStep] = useState(0);

    const [selectedPerType, setSelectedPerType] = useState(perType);
    const [selectedStateType, setSelectedStateType] = useState(stateType);

    const [dropViewGroup, setDropViewGroup] = useState(false);
    const [dropGroup, setDropGroup] = useState("조직 전체");
    const droplist_group = ["조직 전체", ...organization.teams.map(team => team.name)];

    const [testEmail, setTestEmail] = useState(''); // 라이선스 이메일 발송 테스트용
    const [testEmailSuc, setTestEmailSuc] = useState(false); // 라이선스 이메일 발송 테스트용

    const pro = useSelector((s) => s.licenseReducer.pro);
    const art = useSelector((s) => s.licenseReducer.art);
    const all = useSelector((s) => s.licenseReducer.all);

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    useEffect(() => {
        if (mbData?.idx) {
            setLicenseIdValue(mbData?.mb_email);
        }
    }, []);

    useEffect(() => {
        if (!LicenseidValue) {
            setLicenseIdErr(0)
        }
    }, [LicenseidValue]);

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const handlePerChange = (e) => {
        setSelectedPerType(e.target.value);
    };

    const handleStateChange = (e) => {
        setSelectedStateType(e.target.value);
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "education_pop_input") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setLicenseIdValue(value);

            if (!EmailChk.test(value)) {
                setLicenseIdErr(1);
                return;
            } else {
                setLicenseIdErr(0);
            }
        }

        if (name === "test_email") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setTestEmail(value)

            if (!value) {
                setTestEmailSuc(false);
                return;
            }

            if (!EmailChk.test(value)) {
                setTestEmailSuc(false);
                return;
            }

            if (value && EmailChk.test(value)) {
                setTestEmailSuc(true);
            } else {
                setTestEmailSuc(false);
                return;
            }
        }
    }



    const LicenseStateSetFunc = async () => { // 라이선스 활성 관련 이메일
        let sender = {
            idx: mbData?.idx,
            user_name: '이름',
            user_email: testEmail,
            admin_email: mbData?.mb_email,
            admin_name: mbData?.mb_name ? mbData?.mb_name : '관리자',
            state: selectedStateType != '비활성' ? true : false,
            model_type: modelType
        };

        /* console.log('sender', sender); */
        /* return; */
        dispatch(loadingStart());

        await API.post('v1/mypage/LicenseSet', sender).then(({ data }) => {
            /* console.log('체크', data); */

            dispatch(loadingEnd());
            dispatch(open({
                component:
                    <Popup01
                        max_width={'300px'}
                        x_btn={false}
                        text1={'수정되었습니다.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));

        }).catch(err => {
            /* console.log(err.response.data); */
            dispatch(loadingEnd());
            dispatch(open({
                component:
                    <Popup01
                        x_btn={false}
                        text1={'오류가 발생했습니다.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));
        }).finally(() => {

        })
    }

    const [searchWord, setSearchWord] = useState('');
    console.log("stateType : ", stateType, ", popType : ", popType, ", perType : ", perType);

    const popupOpen = useSelector((state) => state.popupReducer.open);

    useEffect(() => {
        if (!popupOpen) {
            setSearchWord('');
        }
    }, [popupOpen]);

    console.log("max_width: ", max_width);

    return (
        <>
            <div
                className={`popup_default01 ${stateType === "할당" && 'page_set_license'}`}
                style={{
                    maxWidth: max_width ? max_width : (stateType === '비활성' ? '600px' : '400px'),
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box"
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div
                    className="popup_content_box"
                >
                    {text1 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{text1_b}</b>
                        </div>
                    }

                    {text2 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text2}</p>
                        </div>
                    }

                    {text2_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text2_b}</b>
                        </div>
                    }

                    {text3 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text3}</p>
                        </div>
                    }

                    {text3_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text3_b}</b>
                        </div>
                    }

                    {title &&
                        <div
                            className="popup_title_box"
                        >
                            <p>{title}</p>
                        </div>
                    }

                    {subTitle &&
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lefttext}</p>
                        </div>
                    }

                    {popType === 'per' &&
                        <div className="licensing_radio_pop">
                            <p className="licensing_radio_pop_title">권한 수정</p>

                            <div className="custom_chk_box profile lang">
                                <input
                                    type="radio"
                                    className="custom_chk_input"
                                    name="licensing_per_set"
                                    id="licensing_per1"
                                    checked={selectedPerType === "User"}
                                    onChange={handlePerChange}
                                    value="User"
                                />
                                <label htmlFor="licensing_per1" className="custom_chk_label">
                                    User
                                </label>
                            </div>

                            <div className="custom_chk_box profile lang">
                                <input
                                    type="radio"
                                    className="custom_chk_input"
                                    name="licensing_per_set"
                                    id="licensing_per2"
                                    checked={selectedPerType === "Manager"}
                                    onChange={handlePerChange}
                                    value="Manager"
                                />
                                <label htmlFor="licensing_per2" className="custom_chk_label">
                                    Manager
                                </label>
                            </div>

                            <div className="custom_chk_box profile lang">
                                <input
                                    type="radio"
                                    className="custom_chk_input"
                                    name="licensing_per_set"
                                    id="licensing_per3"
                                    checked={selectedPerType === "Owner"}
                                    onChange={handlePerChange}
                                    value="Owner"
                                />
                                <label htmlFor="licensing_per3" className="custom_chk_label">
                                    Owner
                                </label>
                            </div>
                        </div>
                    }

                    {popType === 'state' &&
                        <>
                            {
                                stateType === '비활성' ? <div className="licensing_radio_pop">
                                    <p className="licensing_radio_pop_title page_license">
                                        라이선스 할당

                                        <img src={require("../../assets/images/exit-icon.svg").default}
                                            className="popup_x_btn"
                                            onClick={() => {
                                                dispatch(close());
                                            }}
                                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                                        />
                                    </p>

                                    <div className="licensing_info_box">
                                        <div className="search_box popup_sch">
                                            <div
                                                className={`drop_box ${dropViewGroup ? 'on' : ''}`}
                                                onClick={() => {
                                                    setDropViewGroup(!dropViewGroup)
                                                }}
                                            >
                                                {dropGroup}

                                                {dropViewGroup &&
                                                    <div className="drop_list">
                                                        {droplist_group.map((x, i) => (
                                                            <p
                                                                key={i}
                                                                onClick={() => {
                                                                    setDropGroup(x);
                                                                }}
                                                            >
                                                                {x}
                                                            </p>
                                                        ))}
                                                    </div>
                                                }
                                            </div>

                                            <div className="input_box popup">
                                                <input type="text" placeholder="이름, 이메일 검색" onChange={(e) => setSearchWord(e.target.value)} />
                                                <img src={require("../../assets/icon/search_black.svg").default} />
                                            </div>
                                        </div>

                                        <PaginationSetLicense searchTeam={dropGroup} searchWord={searchWord} licenseType={view} license={license} />
                                    </div>
                                </div> :
                                    stateType != '할당' ?
                                        <div className="licensing_radio_pop">
                                            <p className="licensing_radio_pop_title">{lang === 0 ? '라이선스 상태' : 'License Status'}</p>

                                            <div className="custom_chk_box profile lang">
                                                <input
                                                    type="radio"
                                                    className="custom_chk_input"
                                                    name="licensing_state_set"
                                                    id="licensing_state1"
                                                    checked={selectedStateType === "활성"}
                                                    onChange={handleStateChange}
                                                    value="활성"
                                                />
                                                <label htmlFor="licensing_state1" className="custom_chk_label">
                                                    {lang === 0 ? '활성' : 'Active'}
                                                </label>
                                            </div>

                                            <div className="custom_chk_box profile lang">
                                                <input
                                                    type="radio"
                                                    className="custom_chk_input"
                                                    name="licensing_state_set"
                                                    id="licensing_state2"
                                                    checked={selectedStateType === "비활성"}
                                                    onChange={handleStateChange}
                                                    value="비활성"
                                                />
                                                <label htmlFor="licensing_state2" className="custom_chk_label">
                                                    {lang === 0 ? '비활성' : 'Inactive'}
                                                </label>
                                            </div>

                                            {/* <div className="custom_chk_box profile lang">
                                        <input 
                                            type="radio" 
                                            className="custom_chk_input" 
                                            name="licensing_state_set"
                                            id="licensing_state3"
                                            checked={selectedStateType === "만료"}
                                            onChange={handleStateChange}
                                            value="만료"
                                        />
                                        <label htmlFor="licensing_state3" className="custom_chk_label">
                                            만료
                                        </label>
                                    </div> */}
                                        </div>
                                        :
                                        <div className="licensing_radio_pop">
                                            <p className="licensing_radio_pop_title page_license">
                                                라이선스 할당

                                                <img src={require("../../assets/images/exit-icon.svg").default}
                                                    className="popup_x_btn"
                                                    onClick={() => {
                                                        dispatch(close());
                                                    }}
                                                    style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                                                />
                                            </p>

                                            <div className="licensing_info_box">
                                                <div className="search_box popup_sch">
                                                    <div
                                                        className={`drop_box ${dropViewGroup ? 'on' : ''}`}
                                                        onClick={() => {
                                                            setDropViewGroup(!dropViewGroup)
                                                        }}
                                                    >
                                                        {dropGroup}

                                                        {dropViewGroup &&
                                                            <div className="drop_list">
                                                                {droplist_group.map((x, i) => (
                                                                    <p
                                                                        key={i}
                                                                        onClick={() => {
                                                                            setDropGroup(x);
                                                                        }}
                                                                    >
                                                                        {x}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        }
                                                    </div>

                                                    <div className="input_box popup">
                                                        <input type="text" placeholder="이름, 이메일 검색" />
                                                        <img src={require("../../assets/icon/search_black.svg").default} />
                                                    </div>
                                                </div>

                                                <PaginationSetLicense />
                                            </div>
                                        </div>
                            }
                        </>
                    }

                    {(buttonCancel || button || longButton) &&
                        <div className="popup_btn_box">
                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if (cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    // disabled={(popType === 'per' ? selectedPerType === perType : true)}
                                    onClick={async () => {
                                        if (popType === 'per') {
                                            if (perType === 'Owner') {
                                                const uniqueOwnerIds = new Set();

                                                const dataset = [...pro, ...art, ...all];

                                                dataset.forEach(item => {
                                                    if (item.licenseGroup && item.licenseGroup.groupOwner) {
                                                        item.licenseGroup.groupOwner.forEach(owner => uniqueOwnerIds.add(owner.id));
                                                    }
                                                });

                                                console.log("dataset.length : ", uniqueOwnerIds.size, ", uniqueOwnerIds.length <= 1 : ", (uniqueOwnerIds.size <= 1));

                                                if (uniqueOwnerIds.size <= 1) {
                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={lang === 0 ? '소유자는 최소 한 명 이상이어야 합니다.' : 'Owner must be at least one.'}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));
                                                    return;
                                                }
                                            }
                                            dispatch(loadingStart());

                                            if (selectedPerType === 'User') {
                                                const result = await API.deleteF(`license/group/${license.licenseGroup.id}/${perType}/${user.id}`);
                                            } else {
                                                const result = await API.post(`license/group/${license.licenseGroup.id}/${selectedPerType.toLowerCase()}/${user.id}`);
                                            }

                                            await refreshLicenseData(dispatch, mbData.idx);
                                            dispatch(open({
                                                component:
                                                    <Popup01
                                                        max_width={'300px'}
                                                        x_btn={false}
                                                        text1={'수정되었습니다.'}
                                                        longButton={lang === 0 ? '확인' : 'OK'}
                                                    />
                                            }));
                                            dispatch(loadingEnd());
                                        }

                                        if (popType === 'state') {
                                            if (stateType != '할당') {
                                                console.log("license : ", license);
                                                dispatch(loadingStart());
                                                const result = await API.patch(`license/remove/${license.id}`);
                                                console.log(result);
                                                if (result.status === 200) {
                                                    refreshLicenseData(dispatch, mbData.idx);

                                                    dispatch(loadingEnd());

                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={lang === 0 ? '수정되었습니다.' : 'Modified.'}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));
                                                } else {
                                                    dispatch(loadingEnd());
                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                x_btn={false}
                                                                text1={lang === 0 ?
                                                                    '오류가 발생했습니다.' : 'An error occurred.'}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));
                                                }
                                            }
                                        }
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
